/**
 * Sightseer Theme JS
 *
 * Dependencies:
 * - hoverintent.jquery.js
 *
 */



/**
 * Look under your chair! console.log FOR EVERYONE!
 *
 * @see http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
 */
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());



/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var SIGHTSEER = {

  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      setupDropdownMenus();
      searchPlaceholder();

      $('.nav-arrow', '#top-menu').each( function(){
        $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
      });
        
       
    }
  },

  templateIndex : {
    init: function(){
    $("#slideritems").before('<div id="navpager" class="navpager">').cycle({
        fx:     'fade',
    	speed:  'slow',
		timeout: 3000,
		pager:  '#navpager'
   });
    }
  },

  templateProduct : {
    init: function(){
      $('#add-to-cart').bind( 'click', addToCart );
      $('#product-gallery.zoom-in').enhanceGallery();
      $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
    }
  },

  templateCart : {
    init: function(){
      $('#toggle-note').toggle(
        function(){ $('#checkout-addnote').find('textarea').show(); },
        function(){ $('#checkout-addnote').find('textarea').hide();  }
      );

    }
  }

}



/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template{{ template | camelize }}" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

  fire : function(func,funcname, args){
    var namespace = SIGHTSEER;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },

  loadEvents : function(){
    var bodyId = document.body.id;

    UTIL.fire('common');

    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);

/**
 * Balance product grid height after all images have loaded.
 */

$(window).load( function(){

 $('#featured-grid').masonry({

    itemSelector : '.product'
  });
  $('#product-grid').masonry({

    itemSelector : '.product'
  });
 $('#blogpage').masonry({

    itemSelector : '.post'
  });
  if($("html").hasClass('ie8')){
      setTimeout(function(){
          loadbkbg();
      },1000);
  }else{
      loadbkbg();
  }
  
});

/**
 * Support for dropdown menus
 */
 
function setupDropdownMenus(){
  $('#top-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );

  function navRollOver(e){
    $(this).addClass('active').find('ul:first').css('top', $(this).height()).show();
  }
  function navRollOut(e){
    $(this).removeClass('active').find('ul:first').hide();
  }

}



/**
 * Ajaxy add-to-cart
 */
function addToCart(e){

  if (typeof e !== 'undefined') e.preventDefault();

  var form      = $(this).parents('form');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });

}

function addToCartSuccess (jqXHR, textStatus, errorThrown){

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  $('#add-to-cart-msg').hide().addClass('success').html('Item added to cart! <a href="/cart" title="view cart">View cart and check out &raquo;</a>').fadeIn();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
}

function updateCartDesc(data){
  var $cartLinkText = $('.cart-link .icon:first');

  switch(data.item_count){
    case 0:
      $cartLinkText.text('0 items');
      break;
    case 1:
      $cartLinkText.text('1 item');
      break;
    default:
      $cartLinkText.text(data.item_count+' items');
      break;
  }
}



/**
 * Enable placeholder switcheroo in older browsers.
 * @see http://webdesignerwall.com/tutorials/cross-browser-html5-placeholder-text
 */
function searchPlaceholder(){

  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
      })
    });
  }

}
$(document).ready(function(){
    $('#tab-content .description').show();
    $('#tab-nav a').on('click',function(event){
        $('#tab-nav a').removeClass('tab-active');
        $('#tab-content > div').hide();
        var index = $(this).index();
        
        $('#tab-nav a').eq(index).addClass('tab-active');
        $('#tab-content > div').eq(index).show(); 
        event.preventDefault();
    });
    
    $('.psizeselector').click(function(){
        $('#pitemid').val($(this).val());
         $('.psizeselector').removeClass('activebtn');
         $(this).addClass('activebtn');
    });
    
    $('#pitemid').val( $('.psizeselector').eq(0).val());
    $('.psizeselector').eq(0).addClass('activebtn');
});